<template>
  <el-dialog
    :title="$t('cityArea.addArea')"
    :visible.sync="dialogVisible"
    width="70%"
    @close="handleClose"
  >
    <el-form :model="addCityAreaInfo" label-width="120px">
      <el-form-item :label="$t('cityArea.areaName')" required>
        <el-input
          v-model="addCityAreaInfo.areaName"
          :placeholder="$t('cityArea.areaNameRequired')"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('cityArea.areaCode')" required>
        <el-input
          v-model="addCityAreaInfo.areaCode"
          :placeholder="$t('cityArea.areaCodeRequired')"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('cityArea.parent')" required>
        <el-input
          v-model="addCityAreaInfo.parentAreaName"
          disabled
          :placeholder="$t('cityArea.parentRequired')"
        ></el-input>
      </el-form-item>
    </el-form>
    
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="saveOrgInfo">{{ $t('common.save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { saveCityArea } from '@/api/shop/cityAreaApi'

export default {
  name: 'AddCityArea',
  data() {
    return {
      dialogVisible: false,
      addCityAreaInfo: {
        areaCode: '',
        areaName: '',
        areaLevel: '',
        parentAreaCode: '',
        parentAreaName: '',
        lon: '',
        lat: ''
      }
    }
  },
  methods: {
    open(params) {
      this.addCityAreaInfo = {
        ...this.addCityAreaInfo,
        ...params
      }
      this.dialogVisible = true
    },
    handleClose() {
      this.clearAddCityAreaInfo()
    },
    addCityAreaValidate() {
      if (!this.addCityAreaInfo.areaCode) {
        this.$message.warning(this.$t('cityArea.areaCodeRequired'))
        return false
      }
      if (!this.addCityAreaInfo.areaName) {
        this.$message.warning(this.$t('cityArea.areaNameRequired'))
        return false
      }
      if (!this.addCityAreaInfo.parentAreaCode) {
        this.$message.warning(this.$t('cityArea.parentRequired'))
        return false
      }
      return true
    },
    saveOrgInfo() {
      if (!this.addCityAreaValidate()) {
        return
      }

      saveCityArea(this.addCityAreaInfo).then(response => {
        console.log(response)
        this.$message.success(this.$t('cityArea.addSuccess'))
        this.dialogVisible = false
        this.clearAddCityAreaInfo()
        this.$emit('success')
      }).catch(error => {
        console.error('添加地区失败:', error)
        this.$message.error(this.$t('cityArea.addFailed'))
      })
    },
    clearAddCityAreaInfo() {
      this.addCityAreaInfo = {
        areaCode: '',
        areaName: '',
        areaLevel: '',
        parentAreaCode: '',
        parentAreaName: '',
        lon: '',
        lat: ''
      }
    }
  }
}
</script>

<style scoped>
.el-input {
  width: 100%;
}
</style>